import type { HashtagListResponsePageAllOfThreeContentItem } from './hashtagListResponsePageAllOfThreeContentItem';

export type HashtagListResponsePageAllOfThree = {
  content?: HashtagListResponsePageAllOfThreeContentItem[];
};
